<template>
  <CommonLayout footer="floristFooter">
    <FloristHeader @suggestion="suggestion"></FloristHeader>
    <MeetingLayout :type="this.consts.meetingType.floristStyleImageProposal">
      <div class="base-color mh-550 shadow">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="col-sm-12 row">
              <div class="col-sm-6 p-3 mt-2">
                <span>お好みの画像を選択してください。</span>
              </div>
              <!--<div class="col-sm-6 text-right p-3">-->
              <!--  <b-button variant="outline-primary" class="sub-button-color text-nowrap mt-2 mb-2" @click="reload" id="reload">更新</b-button>-->
              <!--</div>-->
            </div>
            <div class="col-sm-12 overflow-auto">
              <div class="card-columns p-3 w-100 image-column-count" v-for="(styleImages, index) in suggetionStyleData()" :key="index">
                <div class="card position-relative border-0 bg-unset card-sqr-gray" v-for="(styleImage, i) in styleImages" :key="i">
                  <div class="p-0" :id="'select-image-' + styleImage.imageId" @click="selectImage(styleImage.imageId, styleImage.styleNumber)">
                    <div>
                      <img :src="styleImage.imagePath" class="w-100 ar-3-2" :ref="styleImage.imageId">
                      <h5 class="position-absolute m-0 image-overlay-text">{{styleImage.styleNumber}}</h5>
                      <img src="~@/assets/img/heart-active.png" class="position-absolute like-icon" style="right: 10px; top: 10px;" v-show="selectedImages.indexOf(styleImage.imageId) >= 0">
                      <img src="~@/assets/img/heart-passive.png" class="position-absolute like-icon" style="right: 10px; top: 10px;" v-show="selectedImages.indexOf(styleImage.imageId) === -1">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import FloristHeader from '@/components/FloristHeader.vue'
import SelectedStyleImage from '@/components/SelectedStyleImage'
import SuggestionStyleModel from '@/models/SuggestionStyleModel'
import SignalingModel from '@/models/SignalingModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'

import Vue from 'vue'
export default {
  name: 'FloristMeetingStyleImageProposal',
  components: { CommonModal, CommonLayout, MeetingLayout, FloristHeader },
  data () {
    return {
      overlayShow: false,
      imageRowMaxNum: 3,
      selectedImages: [],
      isSendFirstSignalingData: false,
      loginStatus: ''
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // 打合せ相手との疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true

        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent('fromFlorist')
        }
      }
    },
    getSignalingData: function (newData, oldData) {
      if (newData['event'] === 'again') {
        // 情報の再送要求が来たら画面の情報を再送する
        this.sendSignalingApiData()

        let selectedList = {}
        for (let value of Object.values(this.selectedImages)) {
          let img = document.getElementById('selected-image-' + value).getElementsByTagName('img')[0]
          selectedList[value] = {
            'url': img.getAttribute('src'),
            'styleNumber': img.dataset.styleNumber
          }
        }
        SignalingModel.sendClickEvent('select-image-0', this, {'selected': selectedList})
        return null
      }
      if (newData['current_path'] && oldData) {
        const synchPass = newData['current_path'].replace('customer', 'florist')
        if (synchPass !== this.$route.path) {
          return this.$router.push(synchPass)
        }
      }
      if (newData['event'] === 'click' && newData.selected) {
        const selectedStyleImages = document.getElementById('selected-style-images')
        while (selectedStyleImages.firstChild) {
          selectedStyleImages.removeChild(selectedStyleImages.firstChild)
        }
        this.selectedImages = Object.keys(newData.selected)
        Object.keys(newData.selected).forEach((id) => {
          let Klass = Vue.extend(SelectedStyleImage)
          let instance = new Klass({
            propsData: {
              url: newData.selected[id].url,
              imageRef: id,
              styleNumber: newData.selected[id].styleNumber,
              isShowStyleNumber: true
            }
          }).$mount()
          // 選択画像欄に追加
          selectedStyleImages.appendChild(instance.$el)
        })
      }
    }
  },
  methods: {
    suggetionStyleData () {
      const store = SuggestionStyleModel.getStore()
      if (!store) {
        return null
      }
      const length = Math.ceil(store.images.length / this.imageRowMaxNum)
      return new Array(length).fill().map((_, i) =>
        store.images.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
    },
    setApiData: async function (isReload = false) {
      this.overlayShow = true

      if (localStorage.getItem('suggestionData') === null) {
        return this.$refs.commonModal.msgBoxOk('提案条件を設定してください')
      }

      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.indexOf(currentProjectType) !== -1) {
        return this.$router.push('/florist/meeting/estimate')
      } else if (this.consts.projectType.main.indexOf(currentProjectType) === -1) {
        this.nextPage()
      }

      let params = {}
      params = JSON.parse(localStorage.getItem('suggestionData'))
      try {
        await SuggestionStyleModel.apiSetStore(this.$bvModal, params, () => {
          const selectedStyleImages = document.getElementById('selected-style-images')
          while (selectedStyleImages.firstChild) {
            selectedStyleImages.removeChild(selectedStyleImages.firstChild)
          }
          this.selectedImages = []
          this.overlayShow = false
        })
      } catch (e) {
        return false
      }

      if (((!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) || isReload) && this.loginStatus['prodInst'] !== '1') {
        this.sendSignalingApiData()
        this.isSendFirstSignalingData = true
      }
    },
    sendSignalingApiData () {
      if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
        // 画面再表示時はお客様側の現在情報を消す。
        SignalingModel.sendClickEvent('reload', this)
      }

      const store = SuggestionStyleModel.getStore()
      if (!store) {
        return
      }
      const count = store.images.length
      for (let i = 0; i < count; i++) {
        const apiRes = {
          'status': store.status,
          'message': store.message,
          'images': store.images[i]
        }
        SignalingModel.sendApiEvent('getSuggestionStyles', this, apiRes)
      }
    },
    nextPage () {
      const targetPath = '/florist/meeting/product_proposal'
      SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
      this.$router.push(targetPath)
    },
    reload () {
      SignalingModel.sendClickEvent('reload', this)
      this.setApiData(true)
    },
    selectImage (imageId, styleNumber) {
      // 操作可能な場合
      if (fstore.getters.isOperationPossible) {
        // 選択解除
        if (this.selectedImages.indexOf(imageId) >= 0) {
          this.selectedImages = this.selectedImages.filter(n => n !== imageId)
          let selectedImage = document.getElementById('selected-image-' + imageId)
          // 選択画像欄から削除
          selectedImage.remove()
          this.sendSignalingSelectedImageData(imageId)
        // 選択
        } else if (this.selectedImages.length < this.config.styleImageMaxSelect) {
          this.sendSignalingSelectedImageData(imageId, {
            [imageId]: {
              'url': this.$refs[imageId][0]['currentSrc'],
              'styleNumber': styleNumber
            }
          })
          this.selectedImages.push(imageId)

          let Klass = Vue.extend(SelectedStyleImage)
          let instance = new Klass({
            propsData: {
              url: this.$refs[imageId][0]['currentSrc'],
              imageRef: imageId,
              styleNumber: styleNumber,
              isShowStyleNumber: true
            }
          }).$mount()

          const selectedStyleImages = document.getElementById('selected-style-images')

          // 選択画像欄に追加
          selectedStyleImages.appendChild(instance.$el)
        }
      }
    },
    sendSignalingSelectedImageData (data, addURLs) {
      let selectedList = {}
      for (let value of Object.values(this.selectedImages)) {
        let img = document.getElementById('selected-image-' + value).getElementsByTagName('img')[0]
        selectedList[value] = {
          'url': img.getAttribute('src'),
          'styleNumber': img.dataset.styleNumber
        }
      }
      if (addURLs) {
        Object.keys(addURLs).forEach((id) => {
          selectedList[id] = addURLs[id]
        })
      }
      SignalingModel.sendClickEvent('select-image-' + data, this, {'selected': selectedList})
    },
    suggestion () {
      const currentProjectType = JSON.parse(localStorage.getItem('suggestionData')).projectType[0]
      if (this.consts.projectType.finish.indexOf(currentProjectType) !== -1) {
        this.$router.push('/florist/meeting/estimate')
      } else if (this.consts.projectType.main.indexOf(currentProjectType) === -1) {
        this.nextPage()
      } else {
        SignalingModel.sendClickEvent('reload', this)
        this.setApiData(true)
      }
    }
  },
  mounted () {
    this.setApiData()
    this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
  },
  destroyed () {
    if (SuggestionStyleModel.getStore()) {
      SuggestionStyleModel.removeStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingStyleImageProposal.vue